import {AppLayout} from "../layout/AppLayout.tsx";
import {PublicHomePage} from "../features/home/pages/PublicHomePage.tsx";
import {SignOutPage} from "../features/home/pages/SignOutPage.tsx";
import {AboutPage} from "../features/home/pages/AboutPage.tsx";
import {ProductsPage} from "../features/home/pages/ProductsPage.tsx";
import {RequireAuth} from "../utils/RequireAuth.tsx";
import {IndexPage as DashboardPage} from "../features/dashboard/pages/IndexPage.tsx";
import {PricingConfigProvider, PricingPage} from "@flexinet/pricing-components";
import {publicPricingConfig, authenticatedPricingConfig} from "./pricing.ts";
import {IndexPage as ApplicationProductsPage} from "../features/application-products/pages/IndexPage.tsx";

export const routesConfig = [{
    path: '/',
    element: <AppLayout/>,
    children: [{
        index: true,
        element: <PublicHomePage/>
    }, {
        path: 'sign-out',
        element: <SignOutPage/>
    }, {
        path: 'about',
        element: <AboutPage/>
    }, {
        path: 'products',
        element: <ProductsPage/>
    }, {
        path: 'pricing',
        element: <PricingConfigProvider config={publicPricingConfig}><PricingPage/></PricingConfigProvider>
    }, {
        path: 'dashboard',
        element: <RequireAuth><DashboardPage/></RequireAuth>
    }, {
        path: 'application-products',
        element: <RequireAuth><PricingConfigProvider config={authenticatedPricingConfig}><ApplicationProductsPage/></PricingConfigProvider></RequireAuth>
    }]
}]
